export default __webpack_public_path__ + "static/media/OpenSans-LightItalic.bdf919ff.ttf";